import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



//content-security-policy
const csp = document.createElement('meta')
let mycontent = `default-src 'self' https://api.ipify.org;
script-src 'self' https://code.jquery.com https://cdn.jsdelivr.net  https://cdnjs.cloudflare.com https://stackpath.bootstrapcdn.com https://maps.googleapis.com https://maxcdn.bootstrapcdn.com 'unsafe-inline';
style-src 'self'  https://fonts.googleapis.com https://stackpath.bootstrapcdn.com  https://cdnjs.cloudflare.com 'unsafe-inline';
font-src 'self' https://fonts.googleapis.com https://fonts.gstatic.com;

connect-src 'self' https://api.ipify.org http://localhost:3000 http://localhost:3003 https://maps.googleapis.com https://cdnjs.cloudflare.com https://development.upnn.co.in:3042 https://lucknow.upnn.co.in:3038 https://property.jda.upda.co.in:3016 https://petadmin.testing.upnn.co.in https://petpublic.testing.upnn.co.in:3011 https://noc.testing.upnn.co.in https://nocpublic.testing.upnn.co.in:3012 https://streetvendor.testing.upnn.co.in https://streetpublic.testing.upnn.co.in:3013 https://lda.property.upda.co.in:3020 ;
img-src 'self' https://api.ipify.org blob:;`

csp.setAttribute('http-equiv', 'Content-Security-Policy');
csp.setAttribute('content', mycontent);
document.head.appendChild(csp)


// Create and append the meta tag & links
const faviconLink = document.createElement('link');
faviconLink.setAttribute('rel', 'icon');
faviconLink.setAttribute('type', 'image/x-icon');
faviconLink.setAttribute('href', './assets/img/logo_pcs.jpg');
document.head.appendChild(faviconLink);

const script = document.createElement('script');
script.setAttribute('src', 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBFYlyaMdqSA-Iz92VL0X21l133iHDtjTo&libraries=places&language=en');
document.head.appendChild(script);


// const cdnBts = document.createElement('script');
// cdnBts.setAttribute('src', 'https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/js/bootstrap.min.js');
// document.head.appendChild(cdnBts);



const googleFont1 = document.createElement('link');
googleFont1.setAttribute('rel', 'stylesheet');
googleFont1.setAttribute('href', 'https://fonts.googleapis.com/css?family=Roboto:300,400,500&display=swap');
document.head.appendChild(googleFont1);


const csvScript = document.createElement('script');
csvScript.setAttribute('src', './assets/js/scripts/CSVExport.js');
document.head.appendChild(csvScript);

